import React, { useRef } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { PagePortfolio } from '../portfolio/PagePortfolio';
import { PageHome } from '../home/PageHome';
import { PageNosotros } from '../nosotros/PageNosotros';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { PageError } from '../utils/PageError';
import { PageContact } from '../contact/PageContact';
import { Thanks } from '../contact/Thanks';

export function Rutas() {
    const location = useLocation();
    const nodeRef = useRef(null); // Usar un solo nodeRef para la animación

    return (
        <TransitionGroup>
            <CSSTransition
                key={location.key}
                classNames='fade-slide'
                timeout={400}
                nodeRef={nodeRef}>

                <div ref={nodeRef}>
                    <Routes location={location}>
                        <Route
                            path='/'
                            element={<PageHome />} />
                        <Route
                            /* path='/clientes' 
                            element={<h1>Nuestros Clientes</h1>} */ />
                        <Route
                            path='/nosotros'
                            element={<PageNosotros />} />
                        <Route
                            path='/portafolio'
                            element={<PagePortfolio />} />
                        <Route
                            path='/contacto'
                            element={<PageContact />} />
                        <Route
                            path='/gracias'
                            element={<Thanks /> } />
                        <Route
                            path='*'
                            element={<PageError />} />
                    </Routes>
                </div>

            </CSSTransition>
        </TransitionGroup>
    );
}